const styles = {
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

export default styles;
